  document.addEventListener('DOMContentLoaded', function () {
    const popupBtn = document.querySelector('.personalise-popup_btn');
    const popupContainer = document.querySelector('.personalise__pop_ctn_container');
    const closeButtons = document.querySelectorAll('.personalise__popclose');
    const applyBtn = document.getElementById('personalise_initial_btn');
    // const applyBtn = document.getElementById('customAddToCartButton');
    const resetBtn = document.getElementById('personalise_reset_btn');
    const addtoCartBtn = document.querySelector('.m-add-to-cart');

    const input1 = document.getElementById('personalise_initial_input');
    const input2 = document.getElementById('personalise_initial_input2');

    const preview1 = document.getElementById('personalise__result');
    const preview2 = document.getElementById('personalise__result2');

    const outputInput1 = document.getElementById('personalise__customInitial');
    const outputInput2 = document.getElementById('personalise__customInitial2');

    if (popupBtn && popupContainer) {
      popupBtn.addEventListener('click', function () {
        popupContainer.style.display = 'block';
      });
    }

    closeButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        popupContainer.style.display = 'none';
      });
    });

    function updatePreview() {
      preview1.textContent = input1.value;
      preview2.textContent = input2.value;
    }

    input1.addEventListener('input', updatePreview);
    input2.addEventListener('input', updatePreview);

   
    applyBtn.style.opacity = '0.5';
    applyBtn.disabled = true;

    input1.addEventListener('input', function () {
        if (input1.value.trim() !== '') {
            applyBtn.style.opacity = '1';  
            applyBtn.disabled = false;    
        } else {
            applyBtn.style.opacity = '0.5'; 
            applyBtn.disabled = true;       
        }
    });


    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
          popupContainer.style.display = 'none';
          outputInput1.value = input1.value;
          outputInput2.value = input2.value;
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        input1.value = '';
        input2.value = '';
        preview1.textContent = '';
        preview2.textContent = '';
      });
    }

    addtoCartBtn.addEventListener('click', function (event) {
      setTimeout(() => {
        input1.value = '';
        input2.value = '';
        preview1.textContent = '';
        preview2.textContent = '';
      }, 10);
    });
  });



  // add product
   localStorage.setItem("embroideryApplyed", false);

  function checkEmbroideryStatus() {
    // console.log(checkEmbroideryStatus,'checkEmbroideryStatus')
    const name = document
      .getElementById("personalise_initial_input")
      ?.value.trim();
    const line2 = document
      .getElementById("personalise_initial_input2")
      ?.value.trim();
    const addText = document.querySelector(".add-embroidery");
    const appliedText = document.querySelector(".applied-embroidery");
    const isEmpty = !name && !line2;

    if (addText && appliedText) {
      addText.style.display = isEmpty ? "block" : "none";
      appliedText.style.display = isEmpty ? "none" : "block";
      localStorage.setItem("embroideryApplyed", !isEmpty);
    }
    // console.log(
    //   localStorage.getItem("embroideryApplyed"),
    //   "embroideryApplyed status check"
    // );
  }

  // Initial embroidery check
  checkEmbroideryStatus();

  // Add to Cart Custom Button Click
  // $("#customAddToCartButton, #personalise_initial_btn").click(function (e) {
  //   e.preventDefault();
  //   console.log("Add to Cart clicked");

  //   const embroideryApplied = localStorage.getItem("embroideryApplyed") === "true";
  //   console.log(embroideryApplied, "embroideryApplied++++");

  //   const quantityInput = document.querySelector(
  //     'form[action="/cart/add"] [name="quantity"]'
  //   );
  //   const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
  //   console.log(quantity, "quantity++++");

  //   const form = document.querySelector('form[action="/cart/add"]');
  //   console.log(form, "form++++");

  //   const formData = new FormData(form);
  //   const mainVariantId = formData.get("id");
  //   console.log(mainVariantId, "mainVariantId++++");

  //   if (!mainVariantId) {
  //     console.error("Main variant ID missing");
  //     return;
  //   }

  //   if (!embroideryApplied) {
  //     console.log("Adding main product without embroidery");
  //     $.ajax({
  //       type: "POST",
  //       url: "/cart/add.js",
  //       dataType: "json",
  //       data: {
  //         id: mainVariantId,
  //         quantity: quantity,
  //       },
  //       success: function () {
  //         localStorage.setItem("embroideryApplyed", false);
  //         if (window.MinimogTheme?.CartDrawer) {
  //           window.MinimogTheme.CartDrawer.onCartDrawerUpdate();
  //           personalise_reset_btn();
  //           window.MinimogTheme.CartDrawer.open();
  //         } else {
  //           // Fallback
  //           const drawer = document.querySelector("m-cart-drawer");
  //           drawer?.onCartDrawerUpdate?.();
  //           drawer?.open?.();
  //         }
  //       },
  //       error: function (err) {
  //         console.error("Error adding main product:", err);
  //       },
  //     });
  //   } else {
  //     console.log("Adding main product with embroidery");
  //     const embroideryName = $("#personalise_initial_input").val().trim() || "";
  //     console.log(embroideryName, "embroideryName++++");
  //     const embroideryLine2 = $("#personalise_initial_input2").val().trim() || "";
  //     console.log(embroideryLine2, "embroideryLine2++++");
  //     const embroideryProductVariantId = "51570499354938";

  //     $.ajax({
  //       type: "POST",
  //       url: "/cart/add.js",
  //       dataType: "json",
  //       data: {
  //         id: mainVariantId,
  //         quantity: quantity,
  //         properties: {
  //           "Embroidery Name": embroideryName,
  //           "Embroidery Line 2": embroideryLine2,
  //         },
  //       },
  //       success: function () {
  //         console.log("Main product added with embroidery properties");
  //         localStorage.setItem("embroideryApplyed", false);

  //         $.ajax({
  //           type: "POST",
  //           url: "/cart/add.js",
  //           dataType: "json",
  //           data: {
  //             id: embroideryProductVariantId,
  //             quantity: quantity,
  //           },
  //           success: function () {
  //             console.log("Embroidery product added to cart");
  //             if (window.MinimogTheme?.CartDrawer) {
  //               window.MinimogTheme.CartDrawer.onCartDrawerUpdate();
  //               personalise_reset_btn();
  //               window.MinimogTheme.CartDrawer.open();
  //             } else {
  //               // Fallback
  //               const drawer = document.querySelector("m-cart-drawer");
  //               drawer?.onCartDrawerUpdate?.();
  //               personalise_reset_btn();
  //               drawer?.open?.();
  //             }
  //           },
  //           error: function (err) {
  //             console.error("Error adding embroidery product:", err);
  //           },
  //         });
  //       },
  //       error: function (err) {
  //         console.error("Error adding main product with embroidery:", err);
  //       },
  //     });
  //   }
  // });




  $("#customAddToCartButton, #personalise_initial_btn").click(function (e) {
  e.preventDefault();
  // console.log("Add to Cart clicked");

  const embroideryApplied = localStorage.getItem("embroideryApplyed") === "true";
  const quantityInput = document.querySelector('form[action="/cart/add"] [name="quantity"]');
  const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
  const form = document.querySelector('form[action="/cart/add"]');
  const formData = new FormData(form);
  const mainVariantId = formData.get("id");

  if (!mainVariantId) {
    // console.error("Main variant ID missing");
    showToast("Please select a product variant.", "error");
    return;
  }

  // ── Toast Notification ───────────────────────────────────────────
  function showToast(message, type) {
    let toast = document.getElementById("cart-toast");
    if (!toast) {
      const style = document.createElement("style");
      style.textContent = `
        #cart-toast {
          position: fixed;
          bottom: 30px;
          left: 50%;
          transform: translateX(-50%) translateY(30px);
          padding: 14px 24px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #fff;
          z-index: 999999;
          opacity: 0;
          transition: opacity 0.3s ease, transform 0.3s ease;
          pointer-events: none;
          white-space: nowrap;
          box-shadow: 0 4px 16px rgba(0,0,0,0.15);
        }
        #cart-toast.show {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
        #cart-toast.success { background: #2e7d32; }
        #cart-toast.error   { background: #c62828; }
      `;
      document.head.appendChild(style);
      toast = document.createElement("div");
      toast.id = "cart-toast";
      document.body.appendChild(toast);
    }

    // Reset classes
    toast.className = "";
    toast.textContent = message;

    void toast.offsetWidth; // force reflow
    toast.classList.add(type === "error" ? "error" : "success");

    setTimeout(() => toast.classList.add("show"), 10);
    setTimeout(() => toast.classList.remove("show"), 3500);
  }
  // ────────────────────────────────────────────────────────────────

  // ── Spinner ──────────────────────────────────────────────────────
  function showSpinner() {
    let overlay = document.getElementById("cart-spinner-overlay");
    if (!overlay) {
      const style = document.createElement("style");
      style.textContent = `
        #cart-spinner-overlay {
          position: fixed; inset: 0;
          background: rgba(255,255,255,0.6);
          z-index: 99999;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cart-spinner {
          width: 46px; height: 46px;
          border: 4px solid #e0e0e0;
          border-top-color: #000;
          border-radius: 50%;
          animation: cart-spin 0.7s linear infinite;
        }
        @keyframes cart-spin { to { transform: rotate(360deg); } }
      `;
      document.head.appendChild(style);
      overlay = document.createElement("div");
      overlay.id = "cart-spinner-overlay";
      overlay.innerHTML = '<div class="cart-spinner"></div>';
      document.body.appendChild(overlay);
    }
    overlay.style.display = "flex";
  }

  function hideSpinner() {
    const overlay = document.getElementById("cart-spinner-overlay");
    if (overlay) overlay.style.display = "none";
  }
  // ────────────────────────────────────────────────────────────────

  // ── Open Minimog Cart Drawer ─────────────────────────────────────
  function openCart() {
    hideSpinner();
    // console.log("Attempting to open cart...");

    const mCartDrawer = document.querySelector("m-cart-drawer");
    if (mCartDrawer && typeof mCartDrawer.open === "function") {
      // console.log("Opening via m-cart-drawer.open()");
      mCartDrawer.open();
      return;
    }

    if (window.MinimogTheme?.CartDrawer) {
      // console.log("Opening via MinimogTheme.CartDrawer.open()");
      window.MinimogTheme.CartDrawer.open();
      return;
    }

    if (window.MinimogTheme?.Stores?.CartDrawer) {
      // console.log("Opening via MinimogTheme.Stores.CartDrawer");
      window.MinimogTheme.Stores.CartDrawer.set({ open: true });
      return;
    }

    const cartIcon = document.querySelector(
      '.m-cart-icon, .cart-icon, [data-open-cart], .js-mini-cart-toggle, [href="#cart-drawer"], .m-header__cart'
    );
    if (cartIcon) {
      // console.log("Opening via cart icon click");
      cartIcon.click();
      return;
    }

    document.dispatchEvent(new CustomEvent("minimog:cart:open"));
    window.dispatchEvent(new CustomEvent("minimog:open-cart"));
  }

  function updateAndOpenCart() {
    const mCartDrawer = document.querySelector("m-cart-drawer");
    if (mCartDrawer && typeof mCartDrawer.onCartDrawerUpdate === "function") {
      mCartDrawer.onCartDrawerUpdate();
    } else if (window.MinimogTheme?.CartDrawer?.onCartDrawerUpdate) {
      window.MinimogTheme.CartDrawer.onCartDrawerUpdate();
    }
    setTimeout(openCart, 300);
  }
  // ────────────────────────────────────────────────────────────────

  if (!embroideryApplied) {
    // console.log("Adding main product without embroidery");
    showSpinner();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: mainVariantId,
        quantity: quantity,
      },
      success: function (response) {
        // console.log("Main product added:", response);
        localStorage.setItem("embroideryApplyed", false);
        if (typeof personalise_reset_btn === "function") personalise_reset_btn();
        updateAndOpenCart();
      },
      error: function (xhr) {
        // console.error("Error adding main product:", xhr.responseText);
        hideSpinner();
        const msg = xhr.responseJSON?.description || "Could not add product to cart. Please try again.";
        showToast(msg, "error");
      },
    });

  } else {
    // console.log("Adding main product with embroidery");
    const embroideryName = $("#personalise_initial_input").val().trim() || "";
    const embroideryLine2 = $("#personalise_initial_input2").val().trim() || "";
    const embroideryProductVariantId = "51570499354938";

    showSpinner();

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: mainVariantId,
        quantity: quantity,
        properties: {
          "Embroidery Name": embroideryName,
          "Embroidery Line 2": embroideryLine2,
        },
      },
      success: function (response) {
        // console.log("Main product added with embroidery:", response);
        localStorage.setItem("embroideryApplyed", false);

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: {
            id: embroideryProductVariantId,
            quantity: quantity,
          },
          success: function (response) {
            // console.log("Embroidery product added:", response);
            if (typeof personalise_reset_btn === "function") personalise_reset_btn();
            updateAndOpenCart();
          },
          error: function (xhr) {
            // console.error("Error adding embroidery product:", xhr.responseText);
            hideSpinner();
            const msg = xhr.responseJSON?.description || "Could not add embroidery to cart. Please try again.";
            showToast(msg, "error");
          },
        });
      },
      error: function (xhr) {
        // console.error("Error adding main product with embroidery:", xhr.responseText);
        hideSpinner();
        const msg = xhr.responseJSON?.description || "Could not add product to cart. Please try again.";
        showToast(msg, "error");
      },
    });
  }
});

  const embroideryVariantId = "51570499354938";
// _+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+
  function getEmbroideryLineItem(cartItems) {
    return cartItems.find((item) => item.variant_id == embroideryVariantId);
  }

  // ---------------------------------
function calculateEmbroideryQtyFromDOM() {
  let total = 0;
  $(".m-cart-item").each(function () {
    const $item = $(this);
    const variantId = $item.data("variant-id");  // or via a hidden input
    const hasEmbroidery = $item.find(".m-cart-item__property").length > 0 && variantId != embroideryVariantId;
    if (hasEmbroidery) {
      const qty = parseInt($item.find(".m-quantity__input").val(), 10) || 0;
      total += qty;
    }
  });
  return total;
}

// +++++++++++++++++++++++++++
  function updateEmbroideryQtyIfNeeded() {
    const expectedQty = calculateEmbroideryQtyFromDOM();
  
    $.getJSON("/cart.js", function (cart) {
      const embroideryItem = getEmbroideryLineItem(cart.items);
      const currentQty = embroideryItem ? embroideryItem.quantity : 0;
  
      if (expectedQty === currentQty) return;
  
      if (embroideryItem) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: "json",
          data: { id: embroideryItem.key, quantity: expectedQty },
          success: function (cart) { refreshCart(); try { updateHasEmbroideryAttributeFromCart(cart).then(() => { try { checkEmbroideryStatus(); } catch(e){console.error(e);} }); } catch(e){console.error(e);} },
        });
      } else if (expectedQty > 0) {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: { id: embroideryVariantId, quantity: expectedQty },
          success: function (resp) { refreshCart(); updateHasEmbroideryAttribute().then(()=>checkEmbroideryStatus()).catch(e=>console.error(e)); },
        });
      }
    });
  }

// -/-/-/-/-/-/-/-/-/-/-/-/-/-/-/
  function refreshCart() {
    if (window.MinimogTheme?.CartDrawer) {
      window.MinimogTheme.CartDrawer.onCartDrawerUpdate();
      window.MinimogTheme.CartDrawer.open();
    } else {
      // Fallback
      const drawer = document.querySelector("m-cart-drawer");
      drawer?.onCartDrawerUpdate?.();
      drawer?.open?.();
    }
    // Ensure the cart-level embroidery attribute reflects current cart contents
    try {
      updateHasEmbroideryAttribute()
        .then(() => { try { checkEmbroideryStatus(); } catch (e) { console.error(e); } })
        .catch(e => console.error(e));
    } catch (e) { console.error(e); }
  }

  // Recalculate and update the cart attribute 'has-embroidery'
  function updateHasEmbroideryAttribute() {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateHasEmbroideryAttributeFromCart(cart));
  }

  function updateHasEmbroideryAttributeFromCart(cart) {
    try {
      let hasEmbroidery = 'false';
      if (cart && cart.items && cart.items.length > 0) {
        hasEmbroidery = cart.items.some(item => {
          if (!item) return false;
          if (item.variant_id == embroideryVariantId) return true;
          if (!item.properties) return false;
          if (item.properties._embroidery === 'Yes') return true;
          if (item.properties['Embroidery Name'] || item.properties['Embroidery Line 2']) return true;
          return false;
        }) ? 'true' : 'false';
      }

      // If no embroidery left, ensure UI is cleared
      try { if (hasEmbroidery === 'false') { typeof personalise_reset_btn === 'function' && personalise_reset_btn(); } } catch(e){/* ignore */}

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'has-embroidery': hasEmbroidery } })
      })
        .then(res => res.json())
        .then(data => console.log('Cart flagged as has-embroidery:', data.attributes && data.attributes['has-embroidery']))
        .catch(err => console.error('Error updating has-embroidery attribute:', err));
    } catch (err) {
      return Promise.reject(err);
    }
  }

  let debounceTimeout;
  function debounceUpdate() {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(updateEmbroideryQtyIfNeeded, 900);
  }
// */*/*/*/*/*/*/*/*/*/*/*/*/*/*
$(document).on("click", ".m-cart-item .m-quantity__button", function () {
  const $item = $(this).closest(".m-cart-item");
  const hasEmbroidery = $item.find(".m-cart-item__property").length > 0;
  if (hasEmbroidery) debounceUpdate();
});

$(document).on("input", ".m-cart-item .m-quantity__input", function () {
  const $item = $(this).closest(".m-cart-item");
  const hasEmbroidery = $item.find(".m-cart-item__property").length > 0;
  if (hasEmbroidery) debounceUpdate();
});

$(document).on("click", ".m-cart-item__remove, .m-cart-item .remove-button", function () {
  const $item = $(this).closest(".m-cart-item");
  const hasEmbroidery = $item.find(".m-cart-item__property").length > 0;
  if (!hasEmbroidery) return;

  const qtyToRemove = parseInt($item.find(".m-quantity__input").val(), 10) || 0;
  // Adjust embroidery accordingly (similar logic)
  updateEmbroideryQtyIfNeeded();
});

// -*/-*/-*/-*/-*/-*/-*/-*/
let removeDebounceTimeout;

// $(document).on("click", ".m-cart-item__remove, [id^=MinimogCartDrawer-Remove-]", function () {
//   const $this = $(this); // preserve the context

//   clearTimeout(removeDebounceTimeout);
//   removeDebounceTimeout = setTimeout(function () {
//     const $info = $this.closest(".m-cart-item__info, .m-cart-item");
//     const hasEmbroidery = $info.find(".m-cart-item__property").length > 0;

//     if (!hasEmbroidery) return;

//     const qtyToRemove = parseInt($info.find("input[data-quantity-variant-id], .m-quantity__input").val(), 10) || 0;

//     $.getJSON("/cart.js", function (cart) {
//       const embroideryItem = getEmbroideryLineItem(cart.items);
//       if (!embroideryItem) return;

//       const newQty = Math.max(0, embroideryItem.quantity - qtyToRemove);

//       $.ajax({
//         type: "POST",
//         url: "/cart/change.js",
//         dataType: "json",
//         data: {
//           id: embroideryItem.key,
//           quantity: newQty,
//         },
//         success: function () {
//           refreshCart();
//         },
//       });
//     });
//   }, 100);
// });

$(document).on("click", ".m-cart-item__remove, [id^=MinimogCartDrawer-Remove-]", function () {
  const $this = $(this);

  // Disable Add to Cart button immediately on click
  const $addToCartBtn = $('[name="add"], [id*="AddToCart"], .m-add-to-cart, .btn-addtocart');
  $addToCartBtn.prop("disabled", true).addClass("is-disabled loading");

  clearTimeout(removeDebounceTimeout);
  removeDebounceTimeout = setTimeout(function () {
    const $info = $this.closest(".m-cart-item__info, .m-cart-item");
    const hasEmbroidery = $info.find(".m-cart-item__property").length > 0;

    if (!hasEmbroidery) {
      // Re-enable if no embroidery, nothing to update
      $addToCartBtn.prop("disabled", false).removeClass("is-disabled loading");
      return;
    }

    const qtyToRemove = parseInt($info.find("input[data-quantity-variant-id], .m-quantity__input").val(), 10) || 0;

    $.getJSON("/cart.js", function (cart) {
      const embroideryItem = getEmbroideryLineItem(cart.items);

      if (!embroideryItem) {
        // Re-enable if no embroidery item found
        $addToCartBtn.prop("disabled", false).removeClass("is-disabled loading");
        return;
      }

      const newQty = Math.max(0, embroideryItem.quantity - qtyToRemove);




      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: embroideryItem.key,
          quantity: newQty,
        },
        success: function (cart) {
          refreshCart();
          try { updateHasEmbroideryAttributeFromCart(cart).then(()=>checkEmbroideryStatus()).catch(e=>console.error(e)); } catch(e){console.error(e);}        
        },
        complete: function () {
          // Re-enable after cart update completes (success or error)
          $addToCartBtn.prop("disabled", false).removeClass("is-disabled loading");
        },
      });
    });
  }, 100);
});

// -*/+_)-*/+_)-*/+_)
function applyEmbroidery() {
  // alert("test");
  const nameInput = document.getElementById("personalise_initial_input");
  const line2Input = document.getElementById("personalise_initial_input2");
  // console.log(nameInput,'nameInput');
  // console.log(line2Input,'nameInput');

  document.getElementById("hiddenEmbroideryName").value =
    nameInput?.value || "";
  document.getElementById("hiddenEmbroideryLine2").value =
    line2Input?.value || "";
  document.getElementById("personalise__result").innerText =
    nameInput?.value || "";
  document.getElementById("personalise__result2").innerText =
    line2Input?.value || "";


fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        'has-embroidery': 'true'
      }
    })
  })
  .then(res => res.json())
  .then(data => console.log('Cart flagged as has-embroidery:', data))
  .catch(err => console.error('Error setting cart attribute:', err));


  checkEmbroideryStatus();
}
// +-*+-*+-*+-*+-*+-*+-*+-*+-*+-*
function personalise_reset_btn() {
  [
    "personalise_initial_input",
    "personalise_initial_input2",
    "hiddenEmbroideryName",
    "hiddenEmbroideryLine2",
  ].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.value = "";
  });

  ["personalise__result", "personalise__result2"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.innerText = "";
  });

  checkEmbroideryStatus();
}



fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    let hasEmbroidery = 'false';

    // Check if cart has items
    if (cart.items.length > 0) {
      // Check if any item has embroidery
      hasEmbroidery = cart.items.some(item => {
        return item.properties && item.properties._embroidery === 'Yes';
        // Change this condition according to your embroidery property
      }) ? 'true' : 'false';
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'has-embroidery': hasEmbroidery
        }
      })
    });
  })
  .then(res => res.json())
  .then(data => {
    console.log('Cart attribute updated:', data.attributes['has-embroidery']);
  })
  .catch(err => console.error(err));
